import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { FeatureFlag, TextKey } from '@mews-commander/enums';
import { useFeatureFlag } from '@mews/framework';
import { useCommanderThunkDispatch } from '@mews-commander/utils';
import { useInvalidateReservationGroupQuery } from '@mews-commander/core/entities';
import { selectionIsConfirmable as selectionIsConfirmableSelector } from '../../selectors/reservationModuleState/reservationSelection';
import { getCheckedReservationIds } from '../../selectors';
import { formCardFactory } from '../formCardFactory';
import { fetchCurrentEnterpriseCheckedReservations, fetchReservationModuleReduxEntities } from '../../actions/actions';
import { RESERVATION_ORDER_ITEMS_EXTENT } from '../../constants';
import { ReservationModuleConfirmationForm } from './ConfirmationForm';

const ReservationConfirmationFormCardElement = formCardFactory({
    FormElement: ReservationModuleConfirmationForm,
    titleTextKey: TextKey.Confirmation,
    dataTestId: 'reservation-confirmation-form',
});
const ReservationConfirmationFormCard = ({ selectionIsConfirmable, ...other }: $TSFixMe) => {
    const { scope } = other;
    const isReservationModuleReactQueryEnabled = useFeatureFlag(FeatureFlag.reservationModuleReactQueryEnabled);
    const dispatch = useCommanderThunkDispatch();
    const invalidateReservationData = useInvalidateReservationGroupQuery(other.scope, {
        invalidateOrderItemsQuery: true,
    });
    const refetchGroup = async () =>
        Promise.all([
            isReservationModuleReactQueryEnabled
                ? invalidateReservationData()
                : dispatch(
                      fetchCurrentEnterpriseCheckedReservations({ scope, extent: RESERVATION_ORDER_ITEMS_EXTENT })
                  ),
            dispatch(fetchReservationModuleReduxEntities(scope, { balances: true })),
        ]);

    if (!selectionIsConfirmable) {
        return null;
    }
    return <ReservationConfirmationFormCardElement {...other} refetchGroup={refetchGroup} />;
};

export default connect(
    // @ts-expect-error $TSFixMeError: No overload matches this call.
    createStructuredSelector({
        selectionIsConfirmable: selectionIsConfirmableSelector,
        reservationIds: getCheckedReservationIds,
    })
)(ReservationConfirmationFormCard);
